import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//MUI
import { Button, Typography } from "@mui/material";

//UI
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
} from "../../../ui/dropdown-menu";

//Icons
import { ReactComponent as ChevronDown } from "../../../../assets/icons/svg/chevron-down.svg";
import { ReactComponent as HelpIcon } from "../../../../assets/icons/svg/question-circle.svg";

//Modals
import CustomModal from "../../../modal/CustomModal";
import MoveItemHelp from "../help/MoveItemHelp";

export const MoveItemModal = ({ locations }) => {
  //TODO:
  //- Add tabs to select move or split and move
  //- Set split amount (amount storing in new location, we will create a new item from this with parent link for this amount)
  //- Disable selecting current location from locations list

  const [locationId, setLocationId] = useState(null);

  // Group locations by type for sectioned dropdown
  const groupedLocations = locations.data.reduce((acc, loc) => {
    const type = loc.type || "Other";
    if (!acc[type]) acc[type] = [];
    acc[type].push(loc);
    return acc;
  }, {});

  const handleLocationSelect = (id) => {
    setLocationId(id);
  };

  const [showHelpModal, setShowHelpModal] = useState(false);

  const handleMove = () => {
    //TODO: Handle move
  };

  return (
    <div className="w-full">
      <CustomModal open={showHelpModal} handleClose={() => setShowHelpModal(false)} type="bottom">
        <MoveItemHelp />
      </CustomModal>
      <div className="p-4 bg-neutral-100 flex flex-row justify-between items-center">
        <Typography variant="h6" className="font-normal">
          Move Item
        </Typography>
        <Button
          size="small"
          disableRipple
          className="hover:bg-transparent border-neutral-400 hover:border-neutral-500"
          variant="outlined"
          onClick={() => setShowHelpModal(true)}
        >
          <HelpIcon className="w-4 h-4 mr-1" />
          Help
        </Button>
      </div>
      <div className="p-4">
        <div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="outlined"
                className="w-full justify-between font-normal rounded-lg border-secondaryText-200 hover:border-primaryText font-sans text-md"
              >
                {locationId
                  ? locations.data.find((loc) => loc._id === locationId)?.name || "Choose a location..."
                  : "Choose a location..."}
                <ChevronDown className="w-3 opacity-50 ml-2" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-[var(--radix-dropdown-menu-trigger-width)] rounded-[8px] z-[1301]">
              {Object.entries(groupedLocations).map(([section, locs]) => (
                <React.Fragment key={section}>
                  <DropdownMenuLabel>{section}</DropdownMenuLabel>
                  {locs.map((loc) => (
                    <DropdownMenuItem
                      key={loc._id}
                      onSelect={() => handleLocationSelect(loc._id)}
                      className={`${
                        locationId === loc._id ? "font-medium text-mainGreen" : "text-secondaryText-600/90"
                      }`}
                    >
                      {loc.name}
                    </DropdownMenuItem>
                  ))}
                </React.Fragment>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        <div className="w-full mt-6">
          <Button
            variant="contained"
            color="primary"
            disabled={!locationId}
            onClick={handleMove}
            disableRipple
            disableElevation
            fullWidth
          >
            Move Item
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  locations: state.pantry.locations,
});

MoveItemModal.propTypes = {
  locations: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(MoveItemModal);
